// src/services/ClientService.ts
import { getSubdomainFromUrl } from "../utils/url";
import { Client } from "../models/Client";
import { clean } from "../utils/utils";
import api from "./api"; // Ensure you import the correct api instance

export const ClientService = {
  async getClient(clientId: string): Promise<Client | null> {
    try {
      const res = await api.get(`/clients/${clientId}`);
      return res.data?.data ?? null;
    } catch (err) {
      console.error("Error fetching client:", err);
      return null;
    }
  },

  async createClient(
    clientData: Omit<Client, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const payload = clean(clientData);
    const res = await api.post(`/clients`, payload);
    return res.data?.data?._id;
  },

  async updateClient(
    clientId: string,
    updatedData: Partial<Omit<Client, "_id" | "createdAt">>,
  ): Promise<void> {
    const payload = clean(updatedData);
    await api.patch(`/clients/${clientId}`, payload);
  },

  async deleteClient(clientId: string): Promise<void> {
    await api.delete(`/clients/${clientId}`);
  },
};
